<template>
  <div>
    <button type="button" class="back-button" @click="goBack">
      <fa-icon :icon="['fal', 'chevron-left']"></fa-icon>
    </button>
  </div>
</template>

<script>
export default {
  name: 'IdentityBackButton',
  props: {
    to: {
      type: String,
      required: true,
    },
  },
  async setup() {},
  methods: {
    async goBack() {
      await navigateTo(this.to);
    },
  },
}
</script>

<style lang="scss" scoped>
.back-button {
  width: 52px;
  border-radius: 50%;
  border: 1px solid #192526;
  background: white;
  font-weight: 700;
}
.back-button:hover {
  border: 1px solid #484443;
  color: #484443;
}
</style>
